<template>
  <div class="create-contact-pad d-flex flex-column">
    <div class="d-flex align-items-center">
      <i class="fa fa-angle-left p-3" @click="$emit('showContacts')"></i>
      <h5 class="m-0 py-2">{{ $t('webrtc.create-contact.title') }}</h5>
    </div>
    <half-circle-spinner
      v-if="createContactLoading"
      :animation-duration="1500"
      :size="25"
      color="#74b9ff"
      class="m-auto"
    />
    <div class="m-auto text-danger" v-if="!!errorMessage">
      <p>{{ errorMessage }}</p>
    </div>
    <div
      class="create-contact-form d-flex flex-column align-items-start p-1"
      v-if="!createContactLoading && !errorMessage"
    >
      <div class="form p-2 w-100">
        <div class="d-flex flex-column align-items-center">
          <b-avatar
            class="mb-2"
            size="lg"
            variant="success"
            :text="avatarText"
          ></b-avatar>
          <b-form-input
            id="contactName"
            v-model="contact.name"
            required
            class="border mb-2"
            :placeholder="$t('webrtc.create-contact.form.name.placeholder')"
          ></b-form-input>
          <b-form-input
            id="contactPhone"
            v-model="contact.phone"
            required
            class="border mb-2"
            :placeholder="$t('webrtc.create-contact.form.phone.placeholder')"
          ></b-form-input>
          <button
            class="btn btn-primary btn-sm"
            @click="createContact()"
            :disabled="!contact.name || !contact.phone"
          >
            {{ $t('webrtc.create-contact.form.create') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactService from '../../services/contact.service.js'
import HalfCircleSpinner from 'epic-spinners/src/components/lib/HalfCircleSpinner'

export default {
  components: {
    HalfCircleSpinner
  },
  props: {
    defaultContactToSave: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      contact: {},
      createContactLoading: false,
      errorMessage: ''
    }
  },
  computed: {
    avatarText() {
      if (!!this.contact.name) {
        const [firstPart, secondPart] = this.contact.name.split(' ')

        const firstLetter = firstPart ? firstPart.slice(0, 1) : ''
        const secondLetter = secondPart ? secondPart.slice(0, 1) : ''
        return firstLetter + secondLetter
      }
      return ''
    }
  },
  methods: {
    async createContact() {
      try {
        this.createContactLoading = true
        await ContactService.createContact(this.contact)
        this.$emit('showContacts')
      } catch (error) {
        if (!!error.response) this.errorMessage = error.response.data.message
        else this.errorMessage = error.message
      } finally {
        this.createContactLoading = false
      }
    }
  },
  mounted() {
    this.contact = this.defaultContactToSave || {}
  }
}
</script>

<style lang="scss" scoped>
.create-contact-pad {
  min-height: inherit;
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: auto;

  /* width */
  &::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 12px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 12px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
</style>
